<template>
    <v-dialog
        v-model="dialog"
        width="700"
        persistent
    >
        <v-card>
            <v-card-title class="text-h5 secondary primary--text">
                Post Term Reports
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="terms"
                    :search="search"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    fixed-header
                    height="50vh"
                >
                    <template v-slot:top>
                       <v-dialog
                            v-model="dialogEdit"
                            max-width="580px"
                            persistent
                        >
                            <v-card
                                v-show="cardPostReport"
                            >
                                <v-card-title>
                                    {{ formText }}
                                </v-card-title>

                                <v-card-text>
                                    <v-data-table
                                        :headers="headersFormLevels"
                                        :items="formLevels"
                                        hide-default-footer
                                    >
                                        <template v-slot:[`item.actions`]="{ item }">
                                            <v-switch
                                                v-model="item.posted"
                                                inset
                                                @change="postReports(item)"
                                            >                                        
                                            </v-switch>
                                        </template> 
                                        
                                        <template v-slot:[`item.status`]="{ item }">
                                            <div v-if="item.status=='posting'">
                                                <v-progress-circular
                                                    indeterminate
                                                    size="24"
                                                    class="mr-3"
                                                ></v-progress-circular> 
                                                Posting...
                                            </div>
                                            <v-chip
                                                v-if="item.status != 'posting'"
                                                :color="item.status ? 'green' : 'red'"
                                                dark
                                                small
                                            >
                                                {{ item.posted ? 'Reports Posted' : 'Reports Not Posted' }}
                                            </v-chip>
                                        </template>
                                    </v-data-table>    
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        depressed
                                        @click="cancel"
                                        class="mr-4"
                                    >
                                        Close
                                    </v-btn>
                                    
                                    <v-btn
                                        color="primary"
                                        @click="postReports({ posted: 1, value: null })"
                                        class="mr-4"
                                    >
                                        Post All
                                    </v-btn>
                                </v-card-actions>

                                <v-overlay 
                                    :value="overlay" 
                                    absolute
                                    color="#000"
                                    opacity="0.6"
                                >
                                    <v-progress-circular
                                        indeterminate
                                        size="64"
                                    ></v-progress-circular>
                                </v-overlay>
                            </v-card>

                            <v-expand-transition>
                                <v-card
                                    color="primary"
                                    dark
                                    v-show="expand"
                                    class="pa-4"
                                >
                                    <v-card-text>
                                        {{ postingText }}
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0 mt-2"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                            </v-expand-transition>
                    </v-dialog>
                        
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn
                            color="primary"
                            outlined
                            @click="editViewTerm(item)"
                            small
                        >
                            <v-icon
                                small
                                class="mr-2"
                            >
                                mdi-pencil
                            </v-icon>
                            Edit
                        </v-btn>
                    </template>

                    
                </v-data-table>
            </v-card-text>

            <v-card-actions class="px-6">
                <v-spacer></v-spacer>
                <v-btn
                    text
                    outlined
                    @click="close"
                >
                    Close
                </v-btn>
            </v-card-actions>
            
            <!-- <v-overlay
                :absolute="true"
                :value="overlay"
            >
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay> -->
        </v-card>
        <v-snackbar
            v-model="snackbar.display"
            :color="snackbar.color"
        >
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar.display = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
    props: {
        dialogOpen: Boolean,
    },

    created: function () {
        this.initialize();
    },

    data: function () {
        return {
            overlay: false,
            dialog: this.dialogOpen,
            terms: [],
            headers: [
                { text: 'Academic Year', value: 'academic_year' },
                { text: 'Term', value: 'term',  },
                { text: 'Posted', value: 'posted' },
                { text: '', value: 'actions', sortable: false },
            ],
            search: '',
            loading: false,
            dialogEdit: false,
            cardPostReport: true,
            editedItem: {},
            expand: false,
            postingText: '',
            snackbar: {
                display: false,
                text: '',
                color: 'primary'
            },
            headersFormLevels: [
                { text: 'Form', value: 'form_level', width: '100px', sortable: false },
                { text: 'Actions', value: 'actions', width: '80px', sortable: false },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Date Posted', value: 'date_posted', width: '150px', sortable: false },
            ],
            formLevels: [
                { form_level: 'Form 1', value: 1, posted: 0, status: '', date_posted: '' },
                { form_level: 'Form 2', value: 2, posted: 0, status: '', date_posted: '' },
                { form_level: 'Form 3', value: 3, posted: 0, status: '', date_posted: '' },
                { form_level: 'Form 4', value: 4, posted: 0, status: '', date_posted: '' },
                { form_level: 'Form 5', value: 5, posted: 0, status: '', date_posted: '' },
                { form_level: 'Form 6', value: 6, posted: 0, status: '', date_posted: '' },
            ],
        }
    },

    computed: {
        formText () {
            return `${this.editedItem.academic_year} Term ${this.editedItem.term} reports`;
        },
    },

    methods: {

        ...mapActions({
            getTermReports: 'settings/getTermReports',
            postTermReports: 'settings/postTermReports',
            getTermReportsPostedByFormLevel: 'settings/getTermReportsPostedByFormLevel',
        }),

        ...mapMutations({
            setEditedTerm: 'settings/setEditedTerm',
            setSelectedTermReportPostedYearTerm: 'settings/setSelectedTermReportPostedYearTerm',
        }),
        async initialize () {
            this.loading = true;
            this.terms = [];
            try {
                const { data } = await this.getTermReports();
                this.mapTermReports(data);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.loading = false;
        },

        mapTermReports (data) {
            data.forEach( record => {
                let posted = Object.entries(record.posted)
                .filter(([, value]) => value === 1)
                .map(([key]) => `Form ${key}` )
                .join(', ')

                if(Object.values(record.posted).every(value => value === 1)){
                    posted = 'All Forms Posted';
                }

                let academicYearString = record.academic_year.toString();
                let academic_year = academicYearString.slice(0,4)  + "-" + academicYearString.slice(4);

                this.terms.push({
                    academic_year_id: record.academic_year,
                    academic_year,
                    term: record.term,
                    academic_term_id: record.academic_term_id,
                    posted 

                })

            })
            console.log(this.terms)
        },

        

        editViewTerm (item) {
            // console.log(item);
            this.setSelectedTermReportPostedYearTerm({ academic_year_id: item.acadmeic_year_id, academic_term_id: item.academic_term_id });
            this.editedItem = item;
            this.cardPostReport = true;
            this.dialogEdit = true;
            this.fetchTermReportsPosted(); 
        },

        async fetchTermReportsPosted(){
            this.overlay = true;
            try {
                const { data } = await this.getTermReportsPostedByFormLevel();
                this.mapFormLevelsPosted(data);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            this.overlay = false;
        },

        mapFormLevelsPosted(data)
        {
            this.formLevels.forEach( formLevel => {
                const match = data.find(l => l.form_level == formLevel.value);
                if(!match) return;

                if(match  && !match?.date_posted){
                    formLevel.posted = match.posted;
                    formLevel.date_posted = null;
                    formLevel.status = match.posted;
                    return;
                }
                
                const date = new Date(match.date_posted.replace(' ', 'T'));
                const formatted = date.toLocaleString("en-US", {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                });
                
                formLevel.posted = match.posted;
                formLevel.date_posted = match.posted ? formatted : null;
                formLevel.status = match.posted;
                
            })
        },

        close () {
            this.$emit('dialog-close');
        },

        cancel(){
            this.dialogEdit = false;
        },

        async postReports(item){
            //post all set overlay
            if(item.value == null) this.overlay = true;
            let termRecord = Object.assign({}, this.editedItem);
            termRecord['posted'] = item.posted ? 1: 0;
            termRecord['form_level'] = item.value;
            let date = new Date();
            termRecord['date_posted'] = date.toLocaleString("sv-SE");
            this.setEditedTerm(termRecord);
            item.status = 'posting';
            try{
                const { data, statusText } = await this.postTermReports();
                console.log(statusText);
                item.status = item.posted ? 1 : 0;
                const date = new Date(data.date_posted.replace(' ', 'T'));
                const formatted = date.toLocaleString("en-US", {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                });

                item.date_posted = formatted;

                if(item.posted == 0) item.date_posted = '';
                this.fetchTermReportsPosted();
                this.initialize();
            }catch(error){
                error.response ? console.log(error.response) : console.log(error);
            }
        },

        async removeReports(){
            this.cardPostReport = false;
            this.postingText = 'Locking reports please stand by'
            this.$nextTick(()=>{
                this.expand = true;
            })
            let termRecord = Object.assign({}, this.editedItem);
            termRecord['posted'] = 0;            
            termRecord['date_posted'] = null;
            //console.log(termRecord);
            this.setEditedTerm(termRecord);            
            try {
                await this.postTermReports();
                this.editedItem['posted'] = 0;
                this.editedItem['date_posted'] = null;
                this.expand = false;
                this.$nextTick(()=>{
                    this.dialogEdit = false;
                })
                
                setTimeout(() => {
                    this.snackbar.text = this.editedItem.year + ' Term ' + this.editedItem.term + ' reports locked'
                    this.snackbar.display = true;
                })
                //console.log(response)
            } catch (error) {
                this.expand = false;
                this.dialogEdit = false;
                 setTimeout(() => {
                    this.snackbar.text = 'Unable to edit. An error occured.'
                    this.snackbar.display = true;
                })
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        }
    }
}
</script>